import { KlaxWelcome } from 'components/blocks/klax-welcome';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function AuthPanelLoader() {
  const { t } = useTranslation();

  return (
    <div
      className="mx-auto flex w-full min-w-0 max-w-[438px] flex-col items-center justify-center gap-4 py-12"
      aria-busy="true"
      aria-live="polite"
    >
      <KlaxWelcome title={t('LOADING', 'Loading...')} />
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-hidden />
    </div>
  );
}
